export const signoutMutation = {
    query: () => ({
        url: '/mp/1/signout',
        method: 'DELETE',
    }),
};
